const SectionTitle: React.FC<{
  title?: string;
  subtitle?: string | null;
  className?: string;
}> = (props) => {
  const { title, subtitle, className } = props || {};
  return (
    <>
      <h2 className={`font-bold text-3xl text-center ${className}`}>{title}</h2>
      {subtitle && (
        <h3 className={`text-xl text-center ${className}`}>{subtitle}</h3>
      )}
    </>
  );
};

export { SectionTitle };
